export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/1376265d92690fd518e46d698aec8208.png";